<div class="checkout-sidebar">
    <header
        class="checkout-sidebar__header"
        [ngClass]="{
            'checkout-sidebar__header--open-on-mobile': isOpenOnMobile,
            'checkout-sidebar__header--without-border': !!actionBannerContent
        }"
    >
        <svg viewBox="0 0 32 32" aria-hidden="true">
            <path d="M16.003 18.626l7.081-7.081L25 13.46l-8.997 8.998-9.003-9 1.917-1.916z" />
        </svg>
        <div>
            <h2>{{ prettyModelName }}</h2>
            <p>{{ edition }}</p>
            <p *ngIf="leasingType$ | async as leasingType">
                {{
                    {
                        optionName: leasingType.name,
                        key: 'optionLabel',
                        selectableOptionId: leasingType.selectedValue.labelId
                    }
                        | optionTranslation
                        | async
                }}
            </p>
        </div>
        <div *ngIf="deal$ | async as deal">
            <p>
                <span
                    class="checkout-sidebar__price"
                    [ngClass]="{ 'checkout-sidebar__price--shifting': isLoadingAmount$ | async }"
                >
                    <ng-container *ngFor="let price of recentPrices; let idx = index">
                        <span
                            class="checkout-sidebar__price-single"
                            [ngClass]="{
                                'checkout-sidebar__price-single--active': idx === 0,
                                'checkout-sidebar__price-single--fading-out': idx === 1
                            }"
                        >
                            {{ price }},-
                        </span>
                    </ng-container>
                </span>
                <span *ngIf="!deal.pricing.incVAT" class="checkout-sidebar__price-text">
                    <ng-container i18n="@@configurator.general.per-month-abbr">p/m</ng-container>&nbsp;<ng-container
                        i18n="@@configurator.general.ex-vat-abbr"
                        >excl. VAT</ng-container
                    >
                </span>
                <span *ngIf="deal.pricing.incVAT" class="checkout-sidebar__price-text">
                    <ng-container i18n="@@configurator.general.per-month-abbr">p/m</ng-container>&nbsp;<ng-container
                        i18n="@@configurator.general.in-vat-abbr"
                        >incl. VAT</ng-container
                    >
                </span>
                <mg-progress-bar [isVisible]="isLoadingAmount$ | async"></mg-progress-bar>
            </p>
        </div>
    </header>

    <div *ngIf="deal$ | async as deal" class="checkout-sidebar__body">
        <mg-checkout-action-banner
            *ngIf="subsidyShowBanner"
            [content]="subsidyBannerContent"
            [color]="subsidyBannerColor"
        ></mg-checkout-action-banner>
        <mg-checkout-action-banner
            *ngIf="actionBannerContent"
            [content]="actionBannerContent"
            [color]="actionBannerColor"
        ></mg-checkout-action-banner>

        <div class="checkout-sidebar__car-options">
            <ul>
                <li *ngIf="carOptions.paint">
                    {{ carOptions.paint }}
                </li>
                <li *ngIf="carOptions.rims">
                    {{ carOptions.rims }}
                </li>
                <li *ngIf="carOptions.steeringWheel">
                    {{ carOptions.steeringWheel }}
                </li>
                <li *ngIf="carOptions.interior">
                    {{ carOptions.interior }}
                </li>
                <li *ngIf="carOptions.autopilot">
                    {{ carOptions.autopilot }}
                </li>
                <ng-container *ngFor="let formField of carOptions | keyvalue | accessoryKeyValueFilter">
                    <li
                        [ngClass]="{
                            'checkout-sidebar__car-option--not-included': !formField.isIncluded
                        }"
                    >
                        {{ formField.label }}
                    </li></ng-container
                >
            </ul>

            <mg-preview-tesla *ngIf="isCarNew" [deal$]="deal$"></mg-preview-tesla>
        </div>

        <details open>
            <summary>
                <h3 class="checkout-sidebar__heading" i18n="@@configurator.sidebar.contract-heading">Contract</h3>
            </summary>
            <dl class="checkout-sidebar__contract-options">
                <ng-container *ngIf="contractOptions.mileage">
                    <dt>{{ contractOptions.mileage.title }}</dt>
                    <dd>{{ contractOptions.mileage.value | number }}</dd>
                </ng-container>
                <ng-container *ngIf="contractOptions.duration">
                    <dt>{{ contractOptions.duration.title }}</dt>
                    <dd i18n="@@deal.summary.value-duration">{{ contractOptions.duration.value }} months</dd>
                </ng-container>
                <ng-container *ngIf="contractOptions.downpayment">
                    <dt>{{ contractOptions.downpayment.title }}</dt>
                    <dd>{{ contractOptions.downpayment.value | tenantCurrency }}</dd>
                </ng-container>
                <ng-container *ngIf="contractOptions.deductible">
                    <dt>{{ contractOptions.deductible.title }}</dt>
                    <dd>{{ contractOptions.deductible.value }}</dd>
                </ng-container>
                <ng-container *ngIf="contractOptions.winterTires">
                    <dt>{{ contractOptions.winterTires.title }}</dt>
                    <dd>{{ contractOptions.winterTires.value }}</dd>
                </ng-container>
                <ng-container *ngIf="contractOptions.premiumConnectivity">
                    <dt>{{ contractOptions.premiumConnectivity.title }}</dt>
                    <dd>{{ contractOptions.premiumConnectivity.value }}</dd>
                </ng-container>
                <ng-container *ngIf="country !== 'DE'">
                    <dt i18n="@@configurator.sidebar.contract-item-one-title">24/7 emergency help</dt>
                    <dd i18n="@@configurator.sidebar.contract-item-one-data">Included</dd>
                </ng-container>
                <ng-container *ngIf="country !== 'DE'">
                    <dt i18n="@@configurator.sidebar.contract-item-two-title">Replacement transport</dt>
                    <dd i18n="@@configurator.sidebar.contract-item-two-data">Included</dd>
                </ng-container>
                <ng-container *ngIf="country !== 'DE'">
                    <dt i18n="@@configurator.sidebar.contract-item-three-title">Charging pass</dt>
                    <dd i18n="@@configurator.sidebar.contract-item-three-data">Included</dd>
                </ng-container>

                <ng-container *ngIf="!contractOptions.deductible && country === 'BE'">
                    <dt>{{ { optionName: 'deductible', key: 'title' } | optionTranslation | async }}</dt>
                    <dd>{{ { optionName: 'deductible', key: 'be' } | optionTranslation | async }}</dd>
                </ng-container>

                <ng-container *ngIf="country === 'NL' && leasingTypeControl?.value === 'PRIVATE'">
                    <dt>Banden</dt>
                    <dd>Inbegrepen</dd>
                </ng-container>

                <ng-container *ngIf="country === 'NL' && leasingTypeControl?.value === 'PRIVATE'">
                    <dt>Reparatie en onderhoud</dt>
                    <dd>Inbegrepen</dd>
                </ng-container>

                <ng-container *ngIf="country === 'NL' && leasingTypeControl?.value === 'PRIVATE'">
                    <dt>Bedrag meer km prijs</dt>
                    <dd>{{ (deal.pricing.privateLeaseMoreKmPriceIncVAT * 100).toFixed(0) }} cent per km incl VAT</dd>
                </ng-container>

                <ng-container *ngIf="country === 'NL' && leasingTypeControl?.value === 'FULLOPERATIONAL'">
                    <dt>Bedrag meer km prijs</dt>
                    <dd>{{ (deal.pricing.moreKmPriceExVAT * 100).toFixed(0) }} cent per km excl VAT</dd>
                </ng-container>
            </dl>

            <div *ngIf="leasingType$ | async as leasingType" class="checkout-sidebar__leasing-type-container">
                <mg-configurator-switch
                    *ngIf="leasingType.selectableValues.length && leasingType.selectableValues.length > 1"
                    [formControl]="leasingTypeControl"
                    [showOnlySelected]="((route$ | async) || {}).id === 'confirm'"
                >
                    <mg-configurator-switch-option
                        *ngFor="let option of leasingType.selectableValues"
                        [label]="
                            { optionName: leasingType.name, key: 'optionLabel', selectableOptionId: option.labelId }
                                | optionTranslation
                                | async
                        "
                        [value]="option.id"
                    ></mg-configurator-switch-option>
                </mg-configurator-switch>
            </div>
        </details>

        <details *ngIf="(tenantHasBijtelling$ | async) && leasingTypeControl?.value !== 'PRIVATE' && isCarNew">
            <summary>
                <h3 class="checkout-sidebar__heading" i18n="@@configurator.sidebar.bijtelling-heading">
                    Bijtelling & fiscal value
                </h3>
            </summary>
            <div class="checkout-sidebar__bijtelling-container">
                <mg-deal-bijtelling [deal$]="deal$"></mg-deal-bijtelling>
            </div>
        </details>

        <details *ngIf="(tenantHasVAA_ATN$ | async) && isCarNew">
            <summary>
                <h3 class="checkout-sidebar__heading" i18n="@@configurator.sidebar.bijtelling-heading">
                    VAA/ATN & CO2 Calculator
                </h3>
            </summary>
            <div class="checkout-sidebar__bijtelling-container">
                <mg-deal-vaa-atn [deal$]="deal$"></mg-deal-vaa-atn>
            </div>
        </details>

        <details open>
            <summary>
                <h3 class="checkout-sidebar__heading" i18n="@@configurator.sidebar.usps-heading">MisterGreen</h3>
            </summary>
            <ul>
                <li i18n="@@configurator.sidebar.usp-one">Tesla specialist</li>
                <li i18n="@@configurator.sidebar.usp-two">Sustainable lease partner</li>
                <li i18n="@@configurator.sidebar.usp-three">10 years of experience in electric driving</li>
            </ul>
        </details>
    </div>
</div>
